import { render, staticRenderFns } from "./Landing3.vue?vue&type=template&id=5e6e3bf8&scoped=true&"
import script from "./Landing3.vue?vue&type=script&lang=js&"
export * from "./Landing3.vue?vue&type=script&lang=js&"
import style0 from "./Landing3.vue?vue&type=style&index=0&id=5e6e3bf8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6e3bf8",
  null
  
)

export default component.exports